module.exports = __webpack_public_path__ + "img/screen-clear-temp-files.cb5724d7.jpg";